import { BASKET_SET } from "../contants/constants";

const initialState = {
  basket: JSON.parse(localStorage.getItem("basket")) || [],
};

export const basket = (state = initialState, action) => {
  switch (action.type) {
    case BASKET_SET:
      localStorage.setItem("basket", JSON.stringify(action.basket));
      return { ...state, basket: action.basket };
    default:
      return state;
  }
};
